import { theme } from 'antd';
import themeGlobalConfig from './themeGlobalConfig';

const themeDarkConfig = {
  ...themeGlobalConfig,
  algorithm: theme.darkAlgorithm,
};

export default themeDarkConfig;
